import React, { useState, useRef } from 'react';
import { Box, Typography } from '@mui/material';


const styles = {
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid black',
        borderRadius: 10,
        width:'80%',
        minHeight:500
    },
}

const FileUpload = ({selectedImages, setSelectedImages}) => {

    const handleDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        const _files = files.map(file=> {
            const reader = new FileReader();
            let height, width;
            reader.onload = function (e) {
                const img = new Image();
                img.onload = function () {
                width = this.width;
                height = this.height;
                    return {file: file, height: height, width: width}
            };

            img.src = e.target.result;
            };

            reader.readAsDataURL(file);
        })

        setSelectedImages(files);
    };
    const handleUploadedFile = (e) => {
        e.preventDefault();
        const files = Array.from(e.target.files);
        const _files = files.map(file=> {
            const reader = new FileReader();
            let height, width;
            reader.onload = function (e) {
                const img = new Image();
                img.onload = function () {
                width = this.width;
                height = this.height;
                    return {file: file, height: height, width: width}
            };

            img.src = e.target.result;
            };

            reader.readAsDataURL(file);
        })

        setSelectedImages(files);
    };

    const fileInputRef = useRef(null);

    const handleDivDoubleClick = () => {
        fileInputRef.current.click();
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    return (
        <Box sx={styles.container}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
        >
                <div onDoubleClick={handleDivDoubleClick}>
                    <Typography variant="h5">Drag and Drop Files Here</Typography>
                    <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    multiple
                    onChange={handleUploadedFile}
                    />
                </div>
        </Box>
    );
};

export default FileUpload;
